import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {AtsService} from '../../_services/AtsService';
import {missions_service} from '../../_services/missions';
import CustomDate from '../../components/Filters/CustomDate';
import CustomSelect from '../../components/Filters/CustomSelect';
import CustomSelectUi from '../../components/ui/CustomSelect';
import FormFeedbackSwicther from '../../features/development/tabs/components/feedbacks/FormFeedbackSwicther';
import {missions_action} from "../../reducers/Missions/actions/getMissionsList";
import "./style.scss";
import Listing from "../../components/ui/Listing/Listing";
import HeaderThead from '../Missions/listing/header/index'
import LineListing from '../Missions/listing/content/index'
import {AffectContext} from "../../context/AffectContext";
import InputBoxDoneTyping from "react-input-box-done-typing";
import Prio from "../Missions/listing/header/filters/Prio";
import ListingInputFilter from "../../components/ListingInputFilter";
import TypeEtp from "../Missions/listing/header/filters/TypeEtp";
import Client from "../Missions/listing/header/filters/Client";
import Grade from "../Missions/listing/header/filters/Grade";

const MyMissionsContainer = props => {
  const [sorting, setSorting] = useState('');
  const [filterOpen, setFilterOpen] = useState(null);
  const [affectModal] = React.useContext(AffectContext);
  const params = new URLSearchParams(props.location.search);

  const [filters, setFilters] = useState({
    'creator.id': localStorage.getItem('user_id')
  });

  useEffect(() => {
    let filtersParams = buildUrl(filters).slice(0, -1)
    if (sorting !== '') {
      filtersParams = `${filtersParams}&${sorting.sortMode}`;
    }
    props.updateList(`?${filtersParams}`, true);
    setFilterOpen(!filterOpen)
  }, [filters, sorting]);

  useEffect(() => {
    if (affectModal.affected) {
      let filtersParams = buildUrl(filters).slice(0, -1)
      if (sorting !== '') {
        filtersParams = `${filtersParams}&${sorting.sortMode}`;
      }
      props.updateList(`?${filtersParams}`, true);
    }
  }, [affectModal]);

  function buildUrl(filters) {
    return Object.entries(filters).reduce((acc, item) => {
      if (typeof item[1] === Object) {
        acc += `${item[0]}=${encodeURIComponent(item[1].join(','))}&`
      } else {
        acc += `${item[0]}=${encodeURIComponent(item[1])}&`
      }
      return acc
    }, '');
  }

  const listingHeader = [
    {label: 'Prio', id: 'priority.id', filter: Prio, filterXPos: 'left'},
    {
      label: 'Besoin  ( <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path fillRule="evenodd" clipRule="evenodd" d="M3.6681 4.57966C2.58462 5.33809 1.99984 6.32192 1.99984 7.33333C1.99984 8.29516 2.52748 9.22988 3.51074 9.9726L3.9331 10.2916L3.24102 11.8488L5.61183 11.0021L5.81186 11.0551C6.48841 11.2342 7.22596 11.3333 7.99984 11.3333C9.72078 11.3333 11.2502 10.844 12.3316 10.087C13.4151 9.32857 13.9998 8.34475 13.9998 7.33333C13.9998 6.32192 13.4151 5.33809 12.3316 4.57966C11.2502 3.82269 9.72078 3.33333 7.99984 3.33333C6.2789 3.33333 4.74948 3.82269 3.6681 4.57966ZM2.90348 3.48735C4.23497 2.55531 6.03888 2 7.99984 2C9.96079 2 11.7647 2.55531 13.0962 3.48735C14.4256 4.41791 15.3332 5.76742 15.3332 7.33333C15.3332 8.89925 14.4256 10.2488 13.0962 11.1793C11.7647 12.1114 9.96079 12.6667 7.99984 12.6667C7.1887 12.6667 6.4065 12.5718 5.67451 12.3955L0.758653 14.1512L2.29411 10.6964C1.30494 9.80765 0.666504 8.64572 0.666504 7.33333C0.666504 5.76742 1.57411 4.41791 2.90348 3.48735Z" fill="#99999B"/>\n' +
        '</svg> commentaires )',
      id: 'title',
      filter: ListingInputFilter,
      termSearch: 'title',
      filterXPos: 'left',
      styles: {width: '35%'}
    },
    {
      label: 'Statut',
      id: 'status',
      options: () => AtsService.getDbalDataForSelect('mission_status_type'),
      termSearch: 'status',
      filter: CustomSelect,
      filterXPos: 'left',
      styles: {width: 175}
    },
    {label: 'Client', id: 'client', filter: Client, filterXPos: 'left'},
    {label: 'Grade', id: 'requiredPositions_id', filter: Grade, filterXPos: 'left'},
    {
      label: 'Chef de proj.',
      id: 'leader.fullName',
      filter: ListingInputFilter,
      termSearch: 'leader.fullName',
      filterXPos: 'right'
    },
    {label: 'Type & ETP.', id: 'etp.id', filter: TypeEtp, filterXPos: 'right', styles: {width: 120}},
    {label: 'Date.', id: 'startDate', termSearch: 'startDate', filter: CustomDate, filterXPos: 'right'}
  ]

  const updateFilters = (value, type) => {
    if (value === null || value === '') {
      setFilters(
        Object.keys(filters)
              .filter(key => type !== key)
              .reduce((obj, key) => {
                obj[key] = filters[key];
                return obj;
              }, {})
      )
    } else {
      setFilters({
        ...filters,
        [type]: value
      })
    }

  }

  const handleMore = (e) => {
    e.stopPropagation();
    props.updateList(props.next);
  };

  function changeStatusFilter(status) {
    if (status === 'Archivé') {
      updateFilters(1, 'isArchived')
    } else {
      updateFilters(0, 'isArchived')
    }
  }

  return (
    <div className="page container mb-3 my-lg-5 py-lg-4 page-mission-list">
      <header className="col-md-12">
        <h1>
          <div className="actions flex align-items-center">
              <span className="mr-3">
                Mes besoins créés
                <small>{props.total > 1 ? `${props.total} résultats` : `${props.total} résultat`} </small>
              </span>
            <FormFeedbackSwicther onSelect={value => changeStatusFilter(value)} options={
              (
                params.get('isArchived') === '0' || params.get('isArchived') === null
              ) ? ['En cours', 'Archivé'] : ['Archivé', 'En cours ']
            }/>
            <CustomSelectUi
              filterMode
              onChange={value => updateFilters(value, 'fiscalYear')}
              value={filters.fiscalYear}
              placeholder={'Chercher par mots clés'}
              options={() => missions_service.getFiscalYearsDatas()}
              style={{
                marginRight: 16
              }}
            />
          </div>
        </h1>
        <InputBoxDoneTyping
          defaultValue={params.get('term')}
          doneTyping={value => updateFilters(value, 'term')}
          placeholder={'Chercher par mots clés'}
        />
      </header>
      <div className="col-md-12">
        <ul className="mission_legende">
          <li>
            <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="0.864014" width="32" height="32" rx="16" fill="#F33F3F" fillOpacity="0.2"/>
              <g clipPath="url(#clip0_10539_144541)">
                <path
                  d="M6.9375 23.6696V24.9265C6.9375 25.0094 6.97042 25.0889 7.02903 25.1475C7.08763 25.2061 7.16712 25.239 7.25 25.239H24.75C24.8329 25.239 24.9124 25.2061 24.971 25.1475C25.0296 25.0889 25.0625 25.0094 25.0625 24.9265V23.6696C25.0622 23.34 24.9311 23.024 24.698 22.791C24.465 22.5579 24.149 22.4268 23.8194 22.4265H22.875V15.5515C22.875 13.7282 22.1507 11.9795 20.8614 10.6902C19.572 9.40084 17.8234 8.67651 16 8.67651C14.1766 8.67651 12.428 9.40084 11.1386 10.6902C9.84933 11.9795 9.125 13.7282 9.125 15.5515V22.4265H8.18063C7.85103 22.4268 7.53503 22.5579 7.30197 22.791C7.06891 23.024 6.93783 23.34 6.9375 23.6696ZM24.4375 23.6696V24.614H7.5625V23.6696C7.56267 23.5058 7.62784 23.3486 7.74373 23.2327C7.85961 23.1169 8.01674 23.0517 8.18063 23.0515H23.8194C23.9833 23.0517 24.1404 23.1169 24.2563 23.2327C24.3722 23.3486 24.4373 23.5058 24.4375 23.6696ZM9.75 15.5515C9.75 13.8939 10.4085 12.3042 11.5806 11.1321C12.7527 9.95999 14.3424 9.30151 16 9.30151C17.6576 9.30151 19.2473 9.95999 20.4194 11.1321C21.5915 12.3042 22.25 13.8939 22.25 15.5515V22.4265H9.75V15.5515Z"
                  fill="#F33F3F" stroke="#F33F3F" strokeWidth="0.117199" strokeMiterlimit="10"/>
                <path
                  d="M16.2703 12.1619C16.2406 12.1176 16.2005 12.0812 16.1534 12.0561C16.1063 12.031 16.0537 12.0178 16.0003 12.0178C15.947 12.0178 15.8944 12.031 15.8473 12.0561C15.8002 12.0812 15.7601 12.1176 15.7303 12.1619L11.3553 19.6619C11.3279 19.7094 11.3135 19.7632 11.3135 19.818C11.3134 19.8728 11.3278 19.9267 11.3552 19.9741C11.3825 20.0216 11.4219 20.0611 11.4693 20.0886C11.5167 20.116 11.5705 20.1306 11.6253 20.1307H20.3753C20.4301 20.1306 20.484 20.116 20.5314 20.0886C20.5788 20.0611 20.6181 20.0216 20.6455 19.9741C20.6729 19.9267 20.6872 19.8728 20.6872 19.818C20.6872 19.7632 20.6727 19.7094 20.6453 19.6619L16.2703 12.1619ZM12.1694 19.5057L16.0003 12.9382L19.8313 19.5057H12.1694Z"
                  fill="#F33F3F" stroke="#F33F3F" strokeWidth="0.117199" strokeMiterlimit="10"/>
                <path d="M16.3125 14.5056H15.6875V17.6306H16.3125V14.5056Z" fill="#F33F3F" stroke="#F33F3F"
                      strokeWidth="0.117199" strokeMiterlimit="10"/>
                <path
                  d="M15.5312 18.5681C15.5312 18.6608 15.5587 18.7515 15.6102 18.8285C15.6618 18.9056 15.735 18.9657 15.8206 19.0012C15.9063 19.0367 16.0005 19.0459 16.0914 19.0279C16.1824 19.0098 16.2659 18.9651 16.3315 18.8996C16.397 18.834 16.4417 18.7505 16.4597 18.6596C16.4778 18.5686 16.4685 18.4744 16.4331 18.3887C16.3976 18.3031 16.3375 18.2299 16.2604 18.1784C16.1833 18.1269 16.0927 18.0994 16 18.0994C15.8757 18.0994 15.7565 18.1488 15.6685 18.2367C15.5806 18.3246 15.5312 18.4438 15.5312 18.5681ZM16.1563 18.5681C16.1563 18.599 16.1471 18.6292 16.1299 18.6549C16.1127 18.6806 16.0883 18.7006 16.0598 18.7125C16.0312 18.7243 15.9998 18.7274 15.9695 18.7214C15.9392 18.7153 15.9114 18.7005 15.8895 18.6786C15.8677 18.6567 15.8528 18.6289 15.8468 18.5986C15.8407 18.5683 15.8438 18.5369 15.8556 18.5083C15.8675 18.4798 15.8875 18.4554 15.9132 18.4382C15.9389 18.421 15.9691 18.4119 16 18.4119C16.0414 18.4119 16.0812 18.4283 16.1105 18.4576C16.1398 18.4869 16.1563 18.5267 16.1563 18.5681Z"
                  fill="#F33F3F" stroke="#F33F3F" strokeWidth="0.117199" strokeMiterlimit="10"/>
                <path d="M16.3125 6.48901H15.6875V8.05151H16.3125V6.48901Z" fill="#F33F3F" stroke="#F33F3F"
                      strokeWidth="0.117199" strokeMiterlimit="10"/>
                <path d="M18.3474 6.75599L18.041 8.28784L18.6539 8.41042L18.9603 6.87856L18.3474 6.75599Z"
                      fill="#F33F3F" stroke="#F33F3F" strokeWidth="0.117199" strokeMiterlimit="10"/>
                <path d="M23.0638 9.66673L21.7637 10.5334L22.1104 11.0535L23.4104 10.1868L23.0638 9.66673Z"
                      fill="#F33F3F" stroke="#F33F3F" strokeWidth="0.117199" strokeMiterlimit="10"/>
                <path d="M21.258 7.83091L20.1533 8.93555L20.5953 9.37749L21.6999 8.27286L21.258 7.83091Z" fill="#F33F3F"
                      stroke="#F33F3F" strokeWidth="0.117199" strokeMiterlimit="10"/>
                <path d="M13.1673 6.74173L12.582 6.96021L13.1286 8.42433L13.7138 8.20585L13.1673 6.74173Z"
                      fill="#F33F3F" stroke="#F33F3F" strokeWidth="0.117199" strokeMiterlimit="10"/>
                <path d="M9.08375 9.61781L8.82422 10.186L10.2455 10.8352L10.505 10.267L9.08375 9.61781Z" fill="#F33F3F"
                      stroke="#F33F3F" strokeWidth="0.117199" strokeMiterlimit="10"/>
                <path d="M10.6685 7.97603L10.2266 8.41797L11.3312 9.5226L11.7731 9.08066L10.6685 7.97603Z"
                      fill="#F33F3F" stroke="#F33F3F" strokeWidth="0.117199" strokeMiterlimit="10"/>
              </g>
              <defs>
                <clipPath id="clip0_10539_144541">
                  <rect width="20" height="20" fill="white" transform="translate(6 5.86401)"/>
                </clipPath>
              </defs>
            </svg>
            Remplacement
          </li>
          <li>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="40" height="40" rx="20" fill="#7ED321" fillOpacity="0.1"/>
              <path fillRule="evenodd" clipRule="evenodd"
                    d="M25.8048 17.1381L18.6667 24.2762L14.1953 19.8048L15.1381 18.862L18.6667 22.3906L24.862 16.1953L25.8048 17.1381Z"
                    fill="#7ED321"/>
            </svg>
            Gagné
          </li>
          <li>
            <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="0.864014" width="32" height="32" rx="16" fill="#003D71" fillOpacity="0.05"/>
              <path
                d="M7.41438 5.16386C7.12898 5.16386 6.89844 5.43096 6.89844 5.6798V28.0479C6.89844 28.315 7.14727 28.5638 7.41438 28.5638H20.9385C21.0767 28.5638 21.2056 28.509 21.3072 28.4074L24.9462 24.7684C25.0386 24.676 25.0935 24.5379 25.1026 24.3998V5.67976C25.1026 5.41266 24.8538 5.16382 24.5775 5.16382L7.41438 5.16386ZM7.93945 6.20487H24.0615V23.8838H20.9384C20.6256 23.8838 20.4225 24.1601 20.4225 24.3998V27.5229H7.93935L7.93945 6.20487ZM16.0005 7.76183C15.1342 7.76183 14.4344 8.4616 14.4344 9.32792C14.4344 10.1851 15.1342 10.8849 16.0005 10.8849C16.8577 10.8849 17.5575 10.1851 17.5575 9.32792C17.5575 8.4616 16.8577 7.76183 16.0005 7.76183ZM16.0005 11.4008C14.4344 11.4008 12.6195 11.9259 12.6195 14.0078H19.3815C19.3815 11.9258 17.5575 11.4008 16.0005 11.4008ZM10.5374 15.8229C10.252 15.8229 10.0214 16.0534 10.0214 16.3479C10.0214 16.6333 10.252 16.8639 10.5374 16.8639H21.4543C21.7488 16.8639 21.9793 16.6333 21.9793 16.3479C21.9793 16.0534 21.7488 15.8229 21.4543 15.8229H10.5374ZM10.5374 18.946C10.252 18.946 10.0214 19.1765 10.0214 19.4619C10.0214 19.7473 10.252 19.987 10.5374 19.987H21.4543C21.7488 19.987 21.9793 19.7473 21.9793 19.4619C21.9793 19.1765 21.7488 18.946 21.4543 18.946H10.5374ZM10.5374 22.06C10.252 22.06 10.0214 22.2997 10.0214 22.5851C10.0214 22.8705 10.252 23.101 10.5374 23.101H21.4543C21.7488 23.101 21.9793 22.8705 21.9793 22.5851C21.9793 22.2997 21.7488 22.06 21.4543 22.06H10.5374ZM21.4543 24.9252H23.3149L21.4543 26.7858V24.9252Z"
                fill="#003D71"/>
            </svg>
            CV gagnant
          </li>
          <li>
            <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="0.864014" width="32" height="32" rx="16" fill="#00B5D4" fillOpacity="0.1"/>
              <path
                d="M16.0021 5.57521C14.0407 5.57521 12.4409 7.22654 12.4409 9.25133C12.4409 10.6171 13.1711 11.8093 14.2466 12.4421C12.2252 13.1859 10.7792 15.1728 10.7792 17.5168V19.0204C10.7783 19.241 10.9504 19.4207 11.1642 19.4217H20.837C21.0507 19.4207 21.2229 19.241 21.2219 19.0204V17.5168C21.2219 15.1736 19.775 13.1876 17.7545 12.4439C18.831 11.8119 19.5603 10.6188 19.5603 9.25107C19.5603 7.22633 17.9634 5.57495 16.001 5.57495L16.0021 5.57521ZM16.0021 6.37392C17.5458 6.37392 18.7876 7.65784 18.7876 9.25133C18.7876 10.8448 17.5458 12.1257 16.0021 12.1257C14.4585 12.1257 13.2156 10.8447 13.2156 9.25133C13.2156 7.65792 14.4585 6.37392 16.0021 6.37392ZM15.9992 12.9244H16.0021C18.4733 12.9254 20.4523 14.9661 20.4523 17.517V18.6233H11.5532V17.517C11.5532 14.9652 13.5282 12.9244 16.0004 12.9244H15.9992ZM8.29562 18.9317C8.05382 18.9237 7.83426 19.0785 7.75496 19.3151L7.1524 21.1032L5.31958 21.1412C5.08552 21.1462 4.88048 21.3039 4.80794 21.5335C4.73443 21.7632 4.81084 22.0158 4.99654 22.1625L6.45699 23.3067L5.92794 25.1168C5.85927 25.3494 5.94051 25.601 6.13105 25.7437C6.32062 25.8875 6.57789 25.8905 6.77132 25.7517L8.2753 24.6705L9.78024 25.7507C9.97271 25.8885 10.229 25.8865 10.4186 25.7437C10.6091 25.602 10.6913 25.3514 10.6236 25.1198L10.0917 23.3077L11.5541 22.1645C11.7417 22.0178 11.8191 21.7642 11.7456 21.5335C11.673 21.3019 11.466 21.1442 11.231 21.1401L9.39821 21.1012L8.79758 19.3141C8.72987 19.1114 8.55675 18.9656 8.35073 18.9367C8.33235 18.9337 8.31398 18.9327 8.2956 18.9317L8.29562 18.9317ZM23.7417 18.9317H23.7407C23.4999 18.9237 23.2813 19.0795 23.202 19.3151L22.5994 21.1032L20.7657 21.1412C20.5316 21.1462 20.3256 21.3039 20.2531 21.5335C20.1805 21.7632 20.256 22.0158 20.4417 22.1625L21.904 23.3067L21.374 25.1168C21.3054 25.3494 21.3866 25.601 21.5762 25.7437C21.7667 25.8875 22.024 25.8905 22.2164 25.7517L23.7204 24.6705L25.2244 25.7507H25.2254C25.4188 25.8895 25.6751 25.8875 25.8656 25.7447C26.0562 25.603 26.1384 25.3514 26.0707 25.1198L25.5378 23.3077L27.0011 22.1645C27.1888 22.0178 27.2661 21.7642 27.1926 21.5325C27.1201 21.3019 26.9131 21.1442 26.6771 21.1401L24.8443 21.1012L24.2427 19.3141H24.2437C24.175 19.1114 24.0019 18.9656 23.7959 18.9367C23.7775 18.9337 23.7591 18.9327 23.7407 18.9317L23.7417 18.9317ZM16.0188 21.227C15.777 21.218 15.5574 21.3738 15.4781 21.6094L14.8756 23.3965L13.0418 23.4355C12.8077 23.4415 12.6027 23.5982 12.5301 23.8279C12.4576 24.0585 12.533 24.3101 12.7187 24.4568L14.1811 25.6L13.6511 27.4111L13.6501 27.4121C13.5815 27.6447 13.6627 27.8963 13.8532 28.0401C14.0438 28.1828 14.3011 28.1858 14.4945 28.046L15.9985 26.9638L17.5034 28.045C17.6959 28.1838 17.9522 28.1808 18.1427 28.0391C18.3323 27.8973 18.4145 27.6467 18.3478 27.4141L17.8168 25.602L19.2782 24.4578H19.2772C19.4649 24.3111 19.5413 24.0585 19.4687 23.8279C19.3952 23.5972 19.1892 23.4395 18.9542 23.4345L17.1214 23.3955L16.5207 21.6074V21.6084C16.453 21.4058 16.2799 21.26 16.0739 21.231C16.0555 21.229 16.0371 21.227 16.0188 21.227L16.0188 21.227Z"
                fill="#00B5D4"/>
            </svg>
            Experts (sous-traitants)
          </li>
          <li>
            <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_10539_144575)">
                <rect y="0.864014" width="32" height="32" rx="16" fill="#FFA300" fillOpacity="0.1"/>
                <path
                  d="M6.5941 15.266C5.7581 15.266 5.4171 14.716 5.4171 14.265C5.4171 13.792 5.8681 13.396 6.6051 13.396C7.3421 13.396 7.7931 13.792 7.7931 14.265C7.7931 14.716 7.4521 15.266 6.6161 15.266H6.5941ZM6.6491 16.41C7.6501 16.41 8.1011 16.96 8.1011 17.51C8.1011 18.104 7.5181 18.588 6.6051 18.588C5.6921 18.588 5.1091 18.104 5.1091 17.51C5.1091 16.949 5.5931 16.377 6.6491 16.41ZM6.6051 19.985C8.4641 19.985 9.7841 19.061 9.7841 17.51C9.7841 16.828 9.2341 15.992 8.4201 15.739C9.0471 15.508 9.4761 14.826 9.4761 14.265C9.4761 12.89 8.2881 12.043 6.6051 12.043C4.9221 12.043 3.7341 12.89 3.7341 14.265C3.7341 14.826 4.1631 15.508 4.7901 15.739C3.9761 15.992 3.4261 16.828 3.4261 17.51C3.4261 19.061 4.7461 19.985 6.6051 19.985ZM17.5628 16.014C17.5628 13.814 16.2428 12.043 14.1198 12.043C11.9858 12.043 10.6988 13.814 10.6988 16.014C10.6988 18.203 11.9858 19.974 14.1198 19.974C16.2428 19.974 17.5628 18.203 17.5628 16.014ZM15.9238 16.014C15.9238 17.466 15.2308 18.643 14.1198 18.643C13.0088 18.643 12.3378 17.466 12.3378 16.014C12.3378 14.551 13.0088 13.374 14.1198 13.374C15.2308 13.374 15.9238 14.551 15.9238 16.014ZM20.7309 19.864H21.8969L26.1649 12.164H25.0099L20.7309 19.864ZM18.3659 14.111C18.3659 15.266 19.3009 16.168 20.5219 16.168C21.7539 16.168 22.6779 15.266 22.6779 14.111C22.6779 12.945 21.7539 12.043 20.5219 12.043C19.3009 12.043 18.3659 12.945 18.3659 14.111ZM19.6199 14.111C19.6199 13.517 20.0599 13.132 20.5219 13.132C21.0169 13.132 21.4459 13.517 21.4459 14.111C21.4459 14.694 21.0169 15.068 20.5219 15.068C20.0599 15.068 19.6199 14.694 19.6199 14.111ZM24.3719 17.928C24.3719 19.083 25.3069 19.985 26.5279 19.985C27.7599 19.985 28.6839 19.083 28.6839 17.928C28.6839 16.762 27.7599 15.86 26.5279 15.86C25.3069 15.86 24.3719 16.762 24.3719 17.928ZM25.6259 17.928C25.6259 17.334 26.0659 16.949 26.5279 16.949C27.0229 16.949 27.4519 17.334 27.4519 17.928C27.4519 18.511 27.0229 18.885 26.5279 18.885C26.0659 18.885 25.6259 18.511 25.6259 17.928Z"
                  fill="#FFA300"/>
              </g>
              <defs>
                <clipPath id="clip0_10539_144575">
                  <rect y="0.864014" width="32" height="32" rx="16" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            Propale 80%
          </li>
        </ul>
      </div>
      <div className="col-md-12 col-lg-12">
        <Listing>
          <Listing.Header>
            {listingHeader.map(
              header => <HeaderThead
                termSearch={header.termSearch}
                filter={filters[header.id]}
                styles={header.styles}
                updateSorting={(key, sortMode) => setSorting({key, sortMode})}
                setFilterOpen={value => setFilterOpen(value === filterOpen ? null : value)}
                filterOpen={filterOpen}
                select_data={props.select_data}
                sorting={sorting}
                selectOptions={header.options}
                header={header}
                onFilterChange={(type, value) => updateFilters(value, type)}
              />)}
          </Listing.Header>
          <Listing.Content>
            {props.list_missions.map(mission => <LineListing listingHeader={listingHeader} sorting={sorting} mission={mission} prio={mission.priority}/>)}
          </Listing.Content>
        </Listing>
        {props.list_missions.length === 0 && <p
          style={{width: "100%", textAlign: "center", padding: '20px 0'}}
        >
          Aucun résutat
        </p>}
        {props.next ? (
          <div className="content-button text-center">
            <button className="button-lg" onClick={handleMore}>
              Voir plus
            </button>
          </div>
        ) : null}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => (
  {
    list_missions: state.Missions.list,
    next: state.Missions.next_url,
    total: state.Missions.total,
    select_data: state.SelectData,
    role: state.Role.role
  }
);

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateList: missions_action.get_missions_list
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MyMissionsContainer);
